if(!customElements.get('universal-slider')) {
	class UniversalSlider extends HTMLElement {
		connectedCallback() {
			this.track = this.querySelector('.js-slider-track');
			this.prevBtn = this.querySelector('.js-slider-prev');
			this.nextBtn = this.querySelector('.js-slider-next');
			
			if(!this.track) return;

			if(this.prevBtn) this.prevBtn.addEventListener('click', () => this.scroll(-1));
			if(this.nextBtn) this.nextBtn.addEventListener('click', () => this.scroll(1));
			
			this.track.addEventListener('scroll', () => this.updateButtons());
			
			setTimeout(() => this.updateButtons(), 100);
			window.addEventListener('resize', () => this.updateButtons());
		}

		scroll(direction) {
			if(this.track.children.length === 0) return;
			const itemWidth = this.track.children[0].offsetWidth;
			const gap = parseInt(window.getComputedStyle(this.track).gap) || 0;
			const scrollAmount = (itemWidth + gap) * direction;
			this.track.scrollBy({ left: scrollAmount, behavior: 'smooth' });
		}

		updateButtons() {
			const scrollLeft = Math.ceil(this.track.scrollLeft);
			const maxScroll = Math.floor(this.track.scrollWidth - this.track.clientWidth);
			
			if(this.prevBtn) this.prevBtn.disabled = scrollLeft <= 2;
			if(this.nextBtn) this.nextBtn.disabled = scrollLeft >= maxScroll - 2;
		}
	}

	customElements.define('universal-slider', UniversalSlider);
}